import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR, paddingLR } = theme.mixins;

  return {
    SmartListSlider: {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToRem(48),
      padding: pxToRem(96) + ' 5.75% 0',
      overflowX: 'hidden',
      '&.AdSmartList': {
        padding: 0,
        overflow: 'visible',
        marginBottom: pxToRem(48),
        [theme.breakpoints.down('md')]: {
          marginBottom: pxToRem(40),
          gap: pxToRem(24)
        },
        '&:last-child': {
          paddingBottom: 0
        },
        '& .eventsCTA': {
          display: 'none !important',
          '&.mobile': {
            display: 'none !important',
          },
          '& .MuiButton-label': {
            '& .btn-txt': {
              color: '#000'
            }
          }
        },
        '& .smartListSliderHeader': {
          '& .eventsTitle': {
            color: '#000',
            display: 'flex',
            flexDirection: 'column',
            gap: pxToRem(8),
            '@media (max-width: 768px)': {
              fontSize: pxToRem(26),
              lineHeight: pxToRem(32),
            },
            '@media (max-width: 375px)': {
              fontSize: pxToRem(22),
            },
            [theme.breakpoints.down('md')]: {
              flexDirection: 'row',
              alignItems: 'flex-end',
              gap: pxToRem(0)
            },
            '& span': {
              fontSize: pxToRem(14),
              lineHeight: pxToRem(16),
              fontFamily: theme.custom.fontFamily.primaryRegular,
              [theme.breakpoints.down('md')]: {
                fontSize: pxToRem(16),
                lineHeight: pxToRem(24),
                ...theme.mixins.marginLeft(12)
              },
            },
          },
        },
        '& .slick-slider': {
          '& .slick-prev': {
            '[dir="rtl"] &': {
              left: 'calc(0px + 12px)'
            },
          },
          '& .slick-nect': {
            '[dir="rtl"] &': {
              right: 'calc(0px - 12px)'
            },
          },
          '& .slick-list': {
            width: 'calc(100% + 24px)',
            overflow: 'hidden !important',
            marginLeft: '0 !important',
            marginRight: '0 !important',
            [theme.breakpoints.down('md')]: {
              width: 'calc(100% + 12px)',
              overflow: 'scroll !important',
            },
            '& .slick-track': {
              paddingLeft: '0 !important',
              '& .slick-slide': {
                '& .heartIcon': {
                  [theme.breakpoints.down('sm')]: {
                    marginTop: pxToRem(16)
                  },
                },
                '& .calenderType': {
                  padding: '24px 0',
                  [theme.breakpoints.down('sm')]: {
                    padding: `${pxToRem(16)} 0`
                  },
                  '& .eventName': {
                    [theme.breakpoints.down('sm')]: {
                      fontSize: pxToRem(12),
                      lineHeight: pxToRem(16)
                    }
                  },
                  '& .eventLocation': {
                    fontFamily: theme.custom.fontFamily.primaryRegular,
                    [theme.breakpoints.down('sm')]: {
                      fontSize: pxToRem(12),
                      lineHeight: pxToRem(16)
                    }
                  },
                  '& .customLink': {
                    [theme.breakpoints.down('sm')]: {
                      fontSize: pxToRem(16),
                      lineHeight: pxToRem(24)

                    },
                    '& .eventTitle': {
                      [theme.breakpoints.down('sm')]: {
                        margin: `${pxToRem(4)} 0`,
                        fontSize: pxToRem(16),
                        lineHeight: pxToRem(24)
                      },
                    }
                  }
                },
                '& .imageWrap': {
                  [theme.breakpoints.down('sm')]: {
                    height: pxToRem(146),
                    minHeight: pxToRem(146),
                  },
                  '& .tagWrapper': {
                    [theme.breakpoints.down('sm')]: {
                      ...theme.mixins.left(16)
                    },
                    '& span': {
                      '[dir="rtl"] &': {
                        fontSize: pxToRem(12),
                        lineHeight: pxToRem(16)
                      },
                    },
                  }
                }
              }
            }
          }
        },
        '& .adCalenderWrapper': {
          minHeight: 'auto'
        }
      },
      '& .eventsTitle': {
        fontFamily: theme.custom.fontFamily.primaryBold,
        fontWeight: '400',
        color: theme.palette.common.black,
        fontStyle: "normal",
        lineHeight: pxToRem(40),

        '@media (max-width: 768px)': {
          fontSize: pxToRem(26),
          lineHeight: pxToRem(32),
        },
        '@media (max-width: 375px)': {
          fontSize: pxToRem(22),
        },
      },

      '& .eventsCTA': {
        fontSize: pxToRem(22),

        '&.mobile': {
          display: 'none',
        },

        '& .MuiButton-endIcon': {
          ...theme.mixins.marginLeft(22),
        },

        '&:hover': {
          '& .MuiButton-label': {
            textDecoration: 'underline',
          },
        },

        [theme.breakpoints.down('md')]: {
          fontSize: pxToRem(16),
          '& .MuiButton-endIcon': {
            ...theme.mixins.marginLeft(16),
          },

          '&.desktop': {
            display: 'none',
          },

          '&.mobile': {
            color: theme.palette.common.white,
            display: 'inline-flex',
            marginTop: pxToRem(6),

            '&.textColorBlack': {
              color: 'black',
            }
          },
        },

        '& .btn-txt': {
          fontFamily: theme.custom.fontFamily.primaryBold,
          fontWeight: '400',
        },
      },

      '&:last-child': {
        paddingBottom: pxToRem(92),

        '& .smartListSliderHeader': {
          zIndex: 1,
          color: theme.palette.common.white,

          '& .eventsTitle': {
            color: theme.palette.common.white,
          },

          '& .eventsCTA': {
            color: theme.palette.common.white,
          },
        },
      },

      [theme.breakpoints.down('md')]: {
        gap: pxToRem(0),
        padding: pxToRem(40) + ' ' + pxToRem(24) + ' 0',

        '&:last-child': {
          paddingBottom: pxToRem(40),
        },
      },

      '& .smartListSliderHeader': {
        display: 'flex',
        justifyContent: 'space-between',
      },

      '& .adCalenderMain': {
        marginTop: pxToRem(20)
      }
    },
  };
});

export default useStyles;
